module.exports = __webpack_public_path__ + "img/Number=77.ce0e2436.png";